<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import { Address, Form, RealStateAddress } from '~/layers/forms/models'

interface Props {
  modelValue: RealStateAddress
  customerAddress?: Address
  validationScope?: string
  argentoInsuranceCompanyId?: number | null
  argentoInsuranceProductId?: number | null
  argentoInsurancebrokerProductId?: number | null
}

const props = withDefaults(defineProps<Props>(), {
  validationScope: Form.realStateAddress,
  argentoInsuranceCompanyId: null,
  argentoInsuranceProductId: null,
  argentoInsurancebrokerProductId: null,
  customerAddress: () => Address.load(),
})

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

watch(
  [computed(() => model.value.asCustomerAddress), computed(() => props.customerAddress)],
  (n, o) => {
    if (n[0] !== o[0])
      model.value = model.value = RealStateAddress.load({ asCustomerAddress: false })

    if (!n[0]) return

    model.value = RealStateAddress.load({ ...props.customerAddress, asCustomerAddress: true })
  },
  {
    deep: true,
  }
)
</script>

<template>
  <FormsGlobalContainer
    v-slot="{ sectionClasses }"
    :identifier="Form.realStateAddress"
  >
    <FormsGlobalTitle
      text="Dirección del inmueble"
      icon-class="icon-[ph--map-pin-bold]"
    />
    <InputContainer class="col-span-full">
      <div class="flex items-center gap-3">
        <PvCheckbox v-model="model.asCustomerAddress" />
        <div>Utilizar la dirección del contratante </div>
      </div>
    </InputContainer>

    <FormsGlobalAddressBaseForm
      v-model="model"
      :argento-insurance-company-id
      :argento-insurance-product-id
      :argento-insurancebroker-product-id
      :validation-scope
      :line-section-classes="sectionClasses({ cols: 2 })"
      :readonly="!!model.asCustomerAddress"
    />
  </FormsGlobalContainer>
</template>
